import {
  /**Register external esignature user */
  REGISTER,
  REGISTER_SUCCESS,
  REGISTER_ERROR,
  REGISTER_CLEAR_DATA,
  /**Login external users */
  LOGIN,
  LOGIN_CLEAR_DATA,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  FORGET_PASSWORD,
  FORGET_PASSWORD_ERROR,
  FORGET_PASSWORD_SUCCESS,
  RESET_PASSWORD,
  RESET_PASSWORD_ERROR,
  RESET_PASSWORD_SUCCESS,
  HASH_VALIDATE,
  HASH_VALIDATE_ERROR,
  HASH_VALIDATE_SUCCESS,
  RESET_APP,
} from "./actionType";

/**REGISTER ESIGNATURE USER */
export const register = (user, navigate) => {
  return {
    type: REGISTER,
    payload: { user, navigate },
  };
};

export const registerSuccess = (user) => {
  return {
    type: REGISTER_SUCCESS,
    payload: user,
  };
};
export const resetApp = () => {
  return {
    type: RESET_APP,
    payload: {},
  };
};

export const registerError = (error) => {
  return {
    type: REGISTER_ERROR,
    payload: error,
  };
};

export const registerClearData = () => {
  return {
    type: REGISTER_CLEAR_DATA,
    payload: {},
  };
};
/**END Esignature register */
/**LOGIN Esignature external users */
export const login = (user, navigate) => {
  return {
    type: LOGIN,
    payload: { user, navigate },
  };
};

export const loginSuccess = (user) => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  };
};

export const loginError = (error) => {
  return {
    type: LOGIN_ERROR,
    payload: error,
  };
};

export const loginClearData = () => {
  return {
    type: LOGIN_CLEAR_DATA,
    payload: {},
  };
};

export const resetPassword = (user, navigate) => {
  return {
    type: RESET_PASSWORD,
    payload: { user, navigate },
  };
};
export const resetPasswordSuccess = (user) => {
  return {
    type: RESET_PASSWORD_SUCCESS,
    payload: user,
  };
};

export const resetPasswordError = (error) => {
  return {
    type: RESET_PASSWORD_ERROR,
    payload: error,
  };
};
/*hash validate */
export const hashValidate = (user, navigate) => {
  return {
    type: HASH_VALIDATE,
    payload: { user, navigate },
  };
};
export const hashValidateSuccess = (user) => {
  return {
    type: HASH_VALIDATE_SUCCESS,
    payload: user,
  };
};

export const hashValidateError = (error) => {
  return {
    type: HASH_VALIDATE_ERROR,
    payload: error,
  };
};

export const forgetPassword = (user, navigate) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, navigate },
  };
};
export const forgetPasswordSuccess = (user) => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: user,
  };
};

export const forgetPasswordError = (error) => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: error,
  };
};
